import CurbsideLaundries from './curbsideLaundries';

// Map connection types to their configuration components
export const APP_CONFIG_COMPONENTS = {
  curbside: CurbsideLaundries,
  // Add more app configurations as needed
};

// Map specific connection IDs to their configuration components
// This ensures that even if the type-based matching fails, we can still
// find the correct configuration component for a given connection by its ID.
// These IDs should match the values in your 'connections' table in Supabase.
export const CONNECTION_ID_MAPPING = {
  // Curbside connection ID
  "3d9019f1-506e-4792-b6bf-5ffe57a2ffa0": CurbsideLaundries,
  
  // You can add more connection IDs here as needed.
  // Example format:
  // "[connection-id-from-database]": ComponentName,
};

/**
 * Get the appropriate configuration component for a connection
 * @param {string} connectionType The type of connection
 * @param {string} connectionId The ID of the connection (optional)
 * @returns {React.Component} The configuration component or null
 */
export const getConfigComponent = (connectionType, connectionId = null) => {
  // First check if we have a direct mapping for this connection ID
  if (connectionId && CONNECTION_ID_MAPPING[connectionId]) {
    return CONNECTION_ID_MAPPING[connectionId];
  }
  
  if (!connectionType) return null;
  
  // Try to match by exact type
  if (APP_CONFIG_COMPONENTS[connectionType]) {
    return APP_CONFIG_COMPONENTS[connectionType];
  }
  
  // If no exact match, try to find by substring
  const connectionTypeLower = connectionType.toLowerCase();
  for (const [type, component] of Object.entries(APP_CONFIG_COMPONENTS)) {
    if (connectionTypeLower.includes(type)) {
      return component;
    }
  }
  
  return null;
}; 